module.exports = __webpack_public_path__ + "static/media/tk.3f259006.gif";